import AlpCheckbox from '@components/Form/AlpCheckbox/AlpCheckbox';
import './SearchFilter.scss';
import useFilter from './hooks/useFilter';
import AnimatedPulse from '@project/components/Loading/AnimatedPulse/AnimatedPulse';

const SearchFilter = () => {
  const {
    gradeLevels,
    conceptZones,
    others,
    concepts,
    resourceTypes,
    showSearchBar,
    selectedFilters,
    loadingFilters,
    handleFilter,
    handleSelectAll,
  } = useFilter();

  return (
    <>
      <aside className={`filter flex flex-col ${!showSearchBar ? 'filter-toggle' : ''}`}>
        <div className="resource-filter">
          <h5>Resource</h5>
          <p>
            Select the Resource below. <br /> You may then filter by Grade and by Concept Zone and by Concept
          </p>
          {loadingFilters && <AnimatedPulse color='blue' />}
          {resourceTypes ? resourceTypes.map((item: any, key: number) => (
            <AlpCheckbox
              key={key}
              id={item.id}
              selectedId={selectedFilters?.resourceTypes ? selectedFilters?.resourceTypes?.map(item => item.id) : []}
              label={item.name}
              color="blue"
              onToggle={() => handleFilter({
                id: item.id,
                name: item.name
              }, 'resourceTypes')}
            />
          )) : null}
        </div>
        <div className='p-2'>
          {others ? others.map((item: any, key: number) => (
            <AlpCheckbox
              key={key}
              id={item.id}
              selectedId={selectedFilters ? selectedFilters?.others?.map(item => item.id) : []}
              label={item.name}
              color="blue"
              onToggle={() => handleFilter({
                id: item.id,
                name: item.name
              }, "others")}
            />
          )) : null}
        </div>
        <div className="year-level-filter">
          <h5>Grade</h5>
          <AlpCheckbox
            id="selectAllYearLevel"
            selectedId={(gradeLevels?.length === selectedFilters?.gradeLevels?.length) ? 'selectAllYearLevel' : ''}
            label="Select All"
            color="blue"
            onToggle={() => handleSelectAll("gradeLevels")}
          />
          <div className="year-level">
            {gradeLevels ? gradeLevels.map((item: any, key: number) => (
              <AlpCheckbox
                key={key}
                id={item.code}
                selectedId={selectedFilters ? selectedFilters?.gradeLevels?.map(item => item.id) : []}
                label={item.name}
                color="blue"
                onToggle={() => handleFilter({
                  id: item.code,
                  name: item.name
                }, "gradeLevels")}
              />
            )) : null}
          </div>
        </div>
        <div className="concept-zone-filter">
          <h5>Concept Zone</h5>
          <AlpCheckbox
            id="selectAllConceptZone"
            selectedId={(conceptZones?.length === selectedFilters?.conceptZones?.length) ? 'selectAllConceptZone' : ''}
            label="Select All"
            color="blue"
            onToggle={() => handleSelectAll("conceptZones")}
          />
          <div className="concept-zone">
            {conceptZones ? conceptZones.map((item: any, key: number) => (
              <AlpCheckbox
                key={key}
                id={item.id}
                selectedId={selectedFilters ? selectedFilters?.conceptZones?.map(item => item.id) : []}
                label={item.name}
                color="blue"
                onToggle={() => handleFilter({
                  id: item.id,
                  name: item.name
                }, "conceptZones")}
              />
            )) : null}
          </div>
        </div>
        <div className="concept-filter">
          <h5>Concepts</h5>
          <AlpCheckbox
            id="selectAllConcept"
            selectedId={(concepts?.length === selectedFilters?.concepts?.length) ? 'selectAllConceptZone' : ''}
            label="Select All"
            color="blue"
            onToggle={() => handleSelectAll("concepts")}
          />
          <div className="concept">
            {concepts ? concepts.map((item: any, key: number) => (
              <AlpCheckbox
                key={key}
                id={item.id}
                selectedId={selectedFilters ? selectedFilters?.concepts?.map(item => item.id) : []}
                label={item.name}
                color="blue"
                onToggle={() => handleFilter({
                  id: item.id,
                  name: item.name
                }, "concepts")}
              />
            )) : null}
          </div>
        </div>
      </aside>
    </>

  );
};

export default SearchFilter;